import { OverviewLayout } from '@layouts/overview/OverviewLayout'
import CommunityPage from '@pages/overview/CommunityPage'
import ConversionPage from '@pages/overview/ConversionPage'
import HomePage from '@pages/overview/Home'
import RevenuePage from '@pages/overview/RevenuePage'
import TrafficPage from '@pages/overview/TrafficPage'
import { Navigate, RouteObject } from 'react-router-dom'

const overviewRoutes: RouteObject[] = [
  {
    element: <OverviewLayout />,
    children: [
      { path: 'home', element: <HomePage /> },
      { path: 'community', element: <CommunityPage /> },
      { path: 'traffic', element: <TrafficPage /> },
      { path: 'conversion', element: <ConversionPage /> },
      { path: 'revenue', element: <RevenuePage /> },
      { index: true, element: <Navigate to="home" replace /> },
      { path: '*', element: <Navigate to="/404" replace /> },
    ],
  },
]

export default overviewRoutes
